import React, { Fragment } from 'react'
import { formatNumberShort } from '../../utils/formatNumberShort'


const TopBarValues = ({
    commissionedCount,
    pmmCommission,
    portalCommission,
    totalOrders
}) => {




    return (
        <Fragment>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.5vmax] mb-[2vmax]">
                {/* Commission Pending */}
                <div className="bg-white dark:bg-slate-950/70 p-[1.5vmax] shadow-sm dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] rounded-xl border border-gray-100 dark:border-indigo-400/20 flex justify-between items-center hover:shadow-md transition-all duration-300">
                    <div>
                        <p className="text-[0.9vmax] font-medium text-gray-500 dark:text-slate-400 uppercase tracking-wider mb-1">Commission Pending</p>
                        <h3 className="text-[2vmax] font-bold text-gray-800 dark:text-white">{commissionedCount || 0}</h3>
                    </div>
                    <div className="w-[3.2vmax] h-[3.2vmax] bg-indigo-50 dark:bg-indigo-500/15 rounded-xl flex items-center justify-center text-indigo-600 dark:text-indigo-300 shadow-sm ring-1 ring-indigo-100 dark:ring-indigo-400/20">
                        <i className="fa-solid fa-receipt text-[1.5vmax]"></i>
                    </div>
                </div>

                {/* PM's Commission */}
                <div className="bg-white dark:bg-slate-950/70 p-[1.5vmax] shadow-sm dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] rounded-xl border border-gray-100 dark:border-emerald-400/20 flex justify-between items-center hover:shadow-md transition-all duration-300">
                    <div>
                        <p className="text-[0.9vmax] font-medium text-gray-500 dark:text-slate-400 uppercase tracking-wider mb-1">PM's Commission</p>
                        <h3 className="text-[2vmax] font-bold text-gray-800 dark:text-white">
                            Rs. {formatNumberShort(totalOrders > 0 ? pmmCommission || 0 : 0)}
                        </h3>
                    </div>
                    <div className="w-[3.2vmax] h-[3.2vmax] bg-emerald-50 dark:bg-emerald-500/15 rounded-xl flex items-center justify-center text-emerald-600 dark:text-emerald-300 shadow-sm ring-1 ring-emerald-100 dark:ring-emerald-400/20">
                        <i className="fa-solid fa-wallet text-[1.5vmax]"></i>
                    </div>
                </div>

                {/* Portal Commission */}
                <div className="bg-white dark:bg-slate-950/70 p-[1.5vmax] shadow-sm dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] rounded-xl border border-gray-100 dark:border-amber-400/20 flex justify-between items-center hover:shadow-md transition-all duration-300">
                    <div>
                        <p className="text-[0.9vmax] font-medium text-gray-500 dark:text-slate-400 uppercase tracking-wider mb-1">Portal Commission</p>
                        <h3 className="text-[2vmax] font-bold text-gray-800 dark:text-white">
                            Rs. {formatNumberShort(totalOrders > 0 ? portalCommission || 0 : 0)}
                        </h3>
                    </div>
                    <div className="w-[3.2vmax] h-[3.2vmax] bg-amber-50 dark:bg-amber-500/15 rounded-xl flex items-center justify-center text-amber-600 dark:text-amber-300 shadow-sm ring-1 ring-amber-100 dark:ring-amber-400/20">
                        <i className="fa-solid fa-building-columns text-[1.5vmax]"></i>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default TopBarValues
